import {
  HTTP_INTERCEPTORS,
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';



const TOKEN_HEADER_KEY = 'Authorization';

// Routes that don't require authentication — 401s here should NOT redirect to login
const PUBLIC_ROUTES = ['/reset-password', '/otp', '/ga-setup', '/ga-verify', '/ga-otp', '/approval/public'];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private readonly auth: AuthService, private readonly router: Router, private readonly toast: ToastService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let authreq = request;

    (window as any).activeApiRequests = ((window as any).activeApiRequests || 0) + 1;

    // get user from localStorage
    const userObj = localStorage.getItem(this.auth.AUTH_USER);
    const parsedUser = userObj ? JSON.parse(userObj) : null;

    // start building headers
    let headers = request.headers.set('version', '1');

    if (parsedUser) {

      headers = headers
        .set(TOKEN_HEADER_KEY, 'Bearer ' + parsedUser.accessToken)
        .set('x-page-url', this.router.url);

      // add group id only if exists
      if (parsedUser.group_id) {
        headers = headers.set('x-group-id', parsedUser.group_id.toString());
      }
    }

    // clone request with headers
    authreq = request.clone({ headers });

    return next.handle(authreq).pipe(
      catchError((error) => {
        if (error.status == 401) {
          // Do NOT redirect to login when the user is on a public/unauthenticated route.
          // A stale auth_user in localStorage causes AppComponent to fire API calls (e.g.
          // getParametersById) even on pages like /reset-password, returning 401 with a
          // stale token — which must NOT kick the user to the login page.
          const currentUrl = this.router.url;
          const isPublicRoute = PUBLIC_ROUTES.some(route => currentUrl.startsWith(route));

          if (!isPublicRoute) {
            localStorage.removeItem('default_company');
            this.auth.updateUser(null);
            this.router.navigateByUrl('/');
          }
        }
        if (error.status == 403) {
          this.toast.failure("Access Denied");
          this.router.navigateByUrl('/app/master/403', { skipLocationChange: true })
        }
        return throwError(() => error);
      }),
      finalize(() => {
        (window as any).activeApiRequests = Math.max(0, ((window as any).activeApiRequests || 1) - 1);
        window.dispatchEvent(new CustomEvent('api_activity'));
      })
    );

  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
